<div class="listado__stats">
    <div class="listado__stat">
        <div class="listado__stat-value">{{ totalNotificaciones }}</div>
        <div class="listado__stat-label">{{ 'COMMON.TOTAL' | translate }}</div>
    </div>
    <div class="listado__stat">
        <div class="listado__stat-value is-muted">{{ notificacionesMostradas }}</div>
        <div class="listado__stat-label">{{ 'COMMON.SHOWING' | translate }}</div>
    </div>
</div>

<button type="button" class="filters-trigger" (click)="filtersOpen = !filtersOpen">
    <mat-icon>tune</mat-icon>
    {{ 'COMMON.FILTERS' | translate }}<span *ngIf="activeFilterCount > 0" class="filter-count">&nbsp;{{ activeFilterCount }}</span>
</button>

<div class="listado__toolbar" [class.is-open]="filtersOpen">
    <div class="listado__filter listado__toolbar-fields">
        <div class="filter-sheet__grip"></div>
        <div class="filter-sheet__head">
            <span>{{ 'COMMON.FILTERS' | translate }}{{ activeFilterCount > 0 ? ' (' + activeFilterCount + ')' : '' }}</span>
            <button type="button" (click)="filtersOpen = false">×</button>
        </div>

        <input type="text" class="em-input" [formControl]="filtroDNI" [placeholder]="'NOTIFICACIONES.PH_DNI' | translate">
        <input type="text" class="em-input" [formControl]="filtroNombre" [placeholder]="'NOTIFICACIONES.PH_NOMBRE' | translate">
        <div class="em-date-range" [formGroup]="filtroFecha">
            <input type="date" class="em-input" formControlName="start" [attr.aria-label]="'COMMON.DATE_START' | translate">
            <span class="em-date-range__sep">–</span>
            <input type="date" class="em-input" formControlName="end" [attr.aria-label]="'COMMON.DATE_END' | translate">
        </div>
        <select class="em-select" [formControl]="filtroTipoEnvio">
            <option value="">{{ 'NOTIFICACIONES.ALL_TYPES' | translate }}</option>
            <option *ngFor="let opcion of listadoTipoEnvio" [value]="opcion.id">{{ opcion.nombre }}</option>
        </select>
        <div class="toggle-container">
            <label class="fb-toggle listado__toggle">
                <input type="checkbox" [formControl]="filtroCargaTotal" [disabled]="cargandoTramites">
                <span class="fb-toggle__track">
                    <span class="fb-toggle__thumb"></span>
                </span>
                <span class="fb-toggle__text">{{ 'NOTIFICACIONES.LOAD_ALL' | translate }}</span>
            </label>
        </div>
        <div class="filter-sheet__foot">
            <button type="button" class="em-btn" (click)="clearFilters()">{{ 'COMMON.CLEAR' | translate }}</button>
            <button type="button" class="em-btn em-btn--primary" (click)="filtersOpen = false">{{ 'COMMON.APPLY' | translate }}</button>
        </div>
    </div>
</div>

<div class="listado listado--cards-accent">
    <mat-table *ngIf="dataSource" #table [dataSource]="dataSource" matSort matSortActive="Fecha creación" matSortDirection="desc" class="table align-middle mb-0 bg-white">
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
            <mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by {{column}}" class="header">
                {{ colLabel(column) }}
            </mat-header-cell>

            <ng-container *ngIf="column !== 'Estado' && column !== 'Leido' && column !== 'Fecha creación'">
                <mat-cell *matCellDef="let object" class="mat-cell"
                    [attr.data-label]="column === 'Procedimiento nombre' ? ('NOTIFICACIONES.PROC_SHORT' | translate) : column === 'Tipo envio' ? ('NOTIFICACIONES.TIPO_ENVIO' | translate) : colLabel(column)"
                    [attr.data-role]="column === 'Concepto remesa' ? 'title' : null"
                    [style]="valuesEnum(object[column])?'color: #025677;':''">
                    {{ object[column] }}
                </mat-cell>
            </ng-container>

            <ng-container *ngIf="column === 'Fecha creación'">
                <mat-cell *matCellDef="let object" class="mat-cell"
                    [attr.data-label]="colLabel(column)"
                    data-role="meta"
                    [style]="valuesEnum(object[column])?'color: #025677;':''">
                    {{ formatDate(object[column]) }}
                </mat-cell>
            </ng-container>

            <ng-container *ngIf="column === 'Leido'">
                <mat-cell *matCellDef="let object" class="mat-cell"
                    [attr.data-label]="'NOTIFICACIONES.READ_LABEL' | translate"
                    data-role="status"
                    [style]="valuesEnum(object[column])?'color: #025677;':''">
                    {{ object[column] ? ('NOTIFICACIONES.READ' | translate) : ('NOTIFICACIONES.UNREAD' | translate) }}
                </mat-cell>
            </ng-container>

            <ng-container *ngIf="column === 'Estado'">
                <mat-cell *matCellDef="let object" class="mat-cell"
                    [attr.data-label]="colLabel(column)"
                    data-role="status">
                    <button type="button" class="estado-pill" [ngClass]="estadoPillClass(object[column])">
                        {{ estadoLabel(object[column]) }}
                    </button>
                </mat-cell>
            </ng-container>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row"></mat-row>
    </mat-table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5" showFirstLastButtons style="padding: 15px;">
    </mat-paginator>

    <div class="load-more-row" *ngIf="paginator?.hasNextPage()">
        <button type="button" class="load-more-btn" (click)="cargarMas()">{{ 'COMMON.LOAD_MORE' | translate }}</button>
    </div>

    <form (submit)="exportarCsv()">
        <button *ngIf="dataSource && isAdmin" class="btn btn-primary m-left" type="submit" (click)="mostrarSpinnerMsg(translate.instant('COMMON.GENERATING_CSV'))">{{ 'COMMON.EXPORT_CSV' | translate }}</button>
    </form>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="true" [name]="'litado_notificaciones_spinner'">
    <p style="color: white">{{ mensajeSpinner }}</p>
</ngx-spinner>
